import { cloneElement, type ReactElement, type ReactNode } from 'react';
import { Box, Text } from '@doist/marketist';
import cn from 'clsx';
import Leaf from 'public/static/award/leaf.svg';
import css from './award.module.css';
type AwardProps = {
  icon: ReactElement;
  className?: string;
  children: ReactNode;
};
function Award({
  children,
  icon,
  className
}: AwardProps) {
  const clonedIcon = cloneElement(icon, {
    width: 24,
    height: 24,
    color: 'var(--display-onlight-tertiary)'
  });
  return <Box className={cn(css.awardContainer, className)} data-sentry-element="Box" data-sentry-component="Award" data-sentry-source-file="award.tsx">
            <Leaf className={css.left} data-sentry-element="Leaf" data-sentry-source-file="award.tsx" />
            <Box className={css.content} data-sentry-element="Box" data-sentry-source-file="award.tsx">
                <Text size="minor-base" width="medium" data-sentry-element="Text" data-sentry-source-file="award.tsx">
                    {children}
                </Text>
                {clonedIcon}
            </Box>
            <Leaf className={css.right} data-sentry-element="Leaf" data-sentry-source-file="award.tsx" />
        </Box>;
}
export { Award };